import { makeAction } from "async-action-creator";

import { createApiThunk } from "../../utils/thunk";
import api from "../../utils/api";

export const FETCH_TEAMS = makeAction("teams/FETCH_TEAMS");

export const fetchTeams = createApiThunk({
  action: FETCH_TEAMS,
  request: (_, { company }) => (company.id ? api.team.list.fetch(company.id) : [])
});
